module.exports = __webpack_public_path__ + "static/media/back-icon-solid.1c968b04.png";